module.exports = __webpack_public_path__ + "img/appAsset-brand--twocheckoutLogo.d53ffb1c.svg";